import { render, staticRenderFns } from "./Inscriptions-pareja.vue?vue&type=template&id=41dbb512&scoped=true&"
import script from "./Inscriptions-pareja.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-pareja.vue?vue&type=script&lang=js&"
import style0 from "./Inscriptions-pareja.vue?vue&type=style&index=0&id=41dbb512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dbb512",
  null
  
)

export default component.exports